import Modal from "react-modal";
import { FunctionComponent, ReactElement } from "react";
import classNames from "classnames";

import "./styles.scss";
import SeityButton from "../SeityButton";

export type SeityModalProps = {
  isOpen: boolean;
  showCloseBtn?: boolean;
  imgCard?: string;
  title?: string;
  text?: string;
  style?: object;
  children?: ReactElement;
  overlayClassName?: string;
  wrapperClassName?: string;
  actionButtons?: Array<{ type: "cancel" | "submit" | "plain-text"; label: string; disable?: boolean }>;
  afterOpenModal?: () => void;
  onClose?: () => void;
  onClickActions?: (idx: number) => void;
};

export const SeityModal: FunctionComponent<SeityModalProps> = ({
  isOpen = false,
  showCloseBtn = false,
  imgCard,
  title = "",
  text = "",
  style,
  children,
  overlayClassName = "",
  wrapperClassName = "",
  actionButtons,
  afterOpenModal = () => {},
  onClose = () => {},
  onClickActions
}): ReactElement => {
  Modal.setAppElement("#root");
  return (
    <Modal
      isOpen={isOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={onClose}
      className={classNames("seity-modal", {
        [wrapperClassName]: wrapperClassName
      })}
      overlayClassName={classNames("seity-modal-overlay", {
        [overlayClassName]: overlayClassName
      })}
      shouldCloseOnOverlayClick={true}
      contentLabel="Seity Modal"
      style={style && { content: { ...style } }}
    >
      {showCloseBtn && (
        <button
          className="ml-auto mb-xl"
          onClick={() => {
            onClose();
          }}
        >
          <img src={require("src/assets/wbn/btn-close.png")} width={24} height={24} />
        </button>
      )}
      {imgCard && <img className="seity-modal__imgCard mb-xl" src={imgCard} />}
      {title?.length > 0 && <h2>{title}</h2>}
      {text?.length > 0 && <p>{text}</p>}
      {children}
      {actionButtons && actionButtons.length > 0 && (
        <div className="seity-modal__btnWrap">
          {actionButtons.map((btn, idx) => {
            return (
              <SeityButton
                key={idx}
                label={btn.label}
                type={btn.type}
                disabled={btn.disable}
                onClick={() => {
                  if (onClickActions) {
                    onClickActions(idx);
                  }
                }}
              />
            );
          })}
        </div>
      )}
    </Modal>
  );
};

export default SeityModal;
